export const UNITED_BOOKING_QUERY_KEY = 'unitedBooking'
